import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { useReferencesContext } from '../../contexts/ReferencesContext/hooks/useReferencesContext.hook';
import { Loading } from '../../components/Loading';
import { useMissionReadyContext } from '../../contexts/MissionContext/hooks/useMissionReadyContext.hook';
import { useMissionSpaceWording } from '../../hooks/useMissionSpaceWording.hook';

import { useMissionPennylaneAccountingQuery } from './hooks/useMissionPennylaneAccountingQuery.hook';
import { PennylaneQuoteAccordion } from './PennylaneQuoteAccordion';

export const PennylaneAccounting = () => {
  const { missionId } = useMissionReadyContext();
  const missionWording = useMissionSpaceWording();
  const { pennylaneUserAccountsCodeMap } = useReferencesContext();
  const { data, isPending } = useMissionPennylaneAccountingQuery(missionId);

  if (isPending) {
    return <Loading />;
  }

  const bridge = data?.findOneMission.accountingInfo?.pennylaneQuoteBridge;

  if (!bridge) {
    return (
      <Typography color="text.secondary" variant="body2">
        {`Aucun devis Pennylane associé à la ${missionWording.name}.`}
      </Typography>
    );
  }

  const accountLabel = pennylaneUserAccountsCodeMap[bridge.userAccount].label;
  const inactiveQuotes = bridge.resolvedInactiveQuotes ?? [];

  return (
    <Stack spacing={2}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography color="text.secondary" variant="body2">
          Compte :
        </Typography>
        <Typography variant="body2">
          <strong>{accountLabel}</strong>
        </Typography>
      </Box>

      <PennylaneQuoteAccordion
        defaultExpanded
        quoteRef={bridge.resolvedQuote}
      />

      {!!inactiveQuotes.length && (
        <Box>
          <Typography color="text.secondary" gutterBottom variant="subtitle2">
            Anciens devis ({inactiveQuotes.length})
          </Typography>
          <Stack spacing={1}>
            {inactiveQuotes.map((inactiveQuote) => (
              <PennylaneQuoteAccordion
                key={inactiveQuote.id}
                quoteRef={inactiveQuote}
              />
            ))}
          </Stack>
        </Box>
      )}
    </Stack>
  );
};
